(function () {
  function readSupport(container) {
    try {
      return JSON.parse(container.querySelector("[data-fourpaw-training-gallery-support]")?.textContent || "[]");
    } catch (_error) {
      return [];
    }
  }

  function createMedia(item) {
    const media = document.createElement("div");
    media.id = `shop-image-${item.id}`;
    media.className = "shop-image-zoom-wrapper image-zoom-enabled fourpaw-training-gallery-support";
    media.dataset.imageGalleryType = "product";

    const image = document.createElement("img");
    image.className = "shop-main-image fourpaw-training-gallery-support__image";
    image.src = item.src;
    image.alt = item.alt || "";
    image.loading = "lazy";
    image.decoding = "async";
    image.width = 1254;
    image.height = 1254;
    image.dataset.zoomSrc = item.src;
    media.appendChild(image);

    const zoomOverlay = document.createElement("div");
    zoomOverlay.className = "image-zoom-overlay";
    media.appendChild(zoomOverlay);
    return media;
  }

  function createThumbnail(item) {
    const thumbnail = document.createElement("button");
    thumbnail.type = "button";
    thumbnail.className = "shop-thumbnail";
    thumbnail.setAttribute("aria-label", item.alt || "");
    thumbnail.setAttribute("aria-controls", `shop-image-${item.id}`);
    thumbnail.setAttribute("aria-current", "false");

    const square = document.createElement("div");
    square.className = "thumb-square";
    const image = document.createElement("img");
    image.src = item.thumb;
    image.alt = item.alt || "";
    image.loading = "lazy";
    image.decoding = "async";
    image.draggable = false;
    image.width = 180;
    image.height = 180;
    square.appendChild(image);
    thumbnail.appendChild(square);
    return thumbnail;
  }

  function register(container, gallery) {
    if (!gallery || container.dataset.fourpawTrainingGalleryReady === "true") return;
    const support = readSupport(container);
    if (!support.length) return;
    support.forEach((item) => {
      gallery.registerVirtualMedia({
        id: item.id,
        media: createMedia(item),
        thumbnail: createThumbnail(item),
      });
    });
    container.dataset.fourpawTrainingGalleryReady = "true";
  }

  function seed(container) {
    if (!container || container.dataset.fourpawTrainingGalleryReady === "true") return;
    const support = readSupport(container);
    if (!support.length) return;

    const imageContainer = container.querySelector(".shop-image-container");
    const thumbnailContainer = container.querySelector(".shop-thumbnails");
    if (!imageContainer || !thumbnailContainer) return;

    const navigation = imageContainer.querySelector(
      ":scope > .shop-mobile-arrows, :scope > .shop-desktop-arrows",
    );

    support.forEach((item) => {
      if (container.querySelector(`[data-media-id="${item.id}"]`)) return;
      const media = createMedia(item);
      const mainMedia = media.querySelector(".shop-main-image");
      const thumbnail = createThumbnail(item);

      media.dataset.mediaId = item.id;
      media.dataset.virtualMedia = "true";
      mainMedia.dataset.mediaId = item.id;
      mainMedia.dataset.virtualMedia = "true";
      thumbnail.dataset.mediaId = item.id;
      thumbnail.dataset.virtualMedia = "true";

      imageContainer.insertBefore(media, navigation || null);
      thumbnailContainer.appendChild(thumbnail);
    });

    container.dataset.fourpawTrainingGalleryReady = "true";
  }

  document.querySelectorAll(".shop-carousel-container").forEach((container) => {
    if (container.querySelector("[data-fourpaw-training-gallery-support]")) seed(container);
  });

  document.addEventListener("product-gallery:ready", (event) => {
    const container = event.target.closest(".shop-carousel-container");
    if (container?.querySelector("[data-fourpaw-training-gallery-support]")) {
      register(container, event.detail?.gallery);
    }
  });

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".shop-carousel-container").forEach((container) => {
      if (!container.querySelector("[data-fourpaw-training-gallery-support]")) return;
      const gallery = container.querySelector(".product-gallery")?.__galleryInstance;
      if (gallery) register(container, gallery);
      else seed(container);
    });
  });
})();
